// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"ktnyP","block":"_1jZHd","head":"nQBGo"};